module.exports = __webpack_public_path__ + "static/media/office.4e30552c.svg";